import React, { useContext, useEffect, useMemo, useState } from "react";
import withName from "../../hoc/withName";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faCopy, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate, useOutletContext, useParams } from "react-router";
import { Chip } from "primereact/chip";
import { Button } from "primereact/button";
import Gallery from "./Gallery";
import { useTranslation } from "react-i18next";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ActionDialog from "./ActionDialog";
import i18n from "../../i18n";
import { DefaultCardLogo } from "./DefaultCardLogo";
import { Integrator } from "./Services/Integrator";
import { Ceres } from "./Services/Ceres";
import { SelfManaged } from "./Services/SelfManaged";
import { SDB } from "./Services/SDB";
import { Arable } from "./Services/Arable";
import { UFL } from "./Services/UFL";
import { CIMIS } from "./Services/CIMIS";
import { ZentraCloud } from "./Services/Zentracloud";
import { Davis } from "./Services/Davis";
import { Irrimax } from "./Services/Irrimax";
import { Weenat } from "./Services/Weenat";
import { Request } from "./Services/Request";
import { Feature } from "./Services/Feature";
import { FarmContext } from "../../contexts/FarmContext";
import { Common } from "./Services/Common";
import { dateFormat } from "../../utils/date";
import RestAPI from "@aws-amplify/api-rest";
import { Seat } from "./Services/Seat";
import { Link } from "react-router-dom";
import { Message } from "primereact/message";
import { DisconnectIcon } from "./Icons/DisconnectIcon";
import { AgViewer } from "./Services/AgViewer";
import { toast } from "react-toastify";
import LoadingDialog from "../Utils/LoadingDialog";
import { JohnDeere } from "./Services/JohnDeere";
import axios from "axios";


const ConnectionDetail = ({usuarioInfo}) => {
    const navigate = useNavigate();
    const [actionDialogState, setActionDialogState] = useState({ visible: false });
    const { id } = useParams();
    const { pathname }  = useLocation();
    const isManageView = pathname.includes("connected");
    /**
     * @type {[typeof import("./data").availableConnections, any]}
     */
    const { availableConnections, paises, farmId, farmConnections } = useOutletContext() || {};
    const { t } = useTranslation();
    const [{ dataFarm }, dispatch] = useContext(FarmContext);
    const [ceresInfo, setCeresInfo] = useState(null);
    const pumpsys = dispatch({ type: "get", path: "pumpsys" });
    const sectorsInfo = dispatch({ type: "get", path: "sectors" });
    const [changeInputType, setChangeInputType] = useState(false);
    const [changeInputTypeAPI, setChangeInputTypeAPI] = useState(false);
    const [loading, setLoading] = useState(false);

    const data = useMemo(() => {
        const connection = availableConnections?.find(c => c.marketplace_servicio_id === +id);
        if (isManageView){
            const price = connection?.usd_price;
            const connected = farmConnections?.find(c => c.connection_id === id);
            if (connected) connected.usd_price = price;
            return connected;
        }
        return connection;
    }, [availableConnections, farmConnections, id, isManageView]);
    const ceresDeviceCache = useMemo(() => ({}), []);
    const services_enabled = farmConnections?.filter((c) => c?.marketplace_servicio_id ===data?.marketplace_servicio_id);
    const AUTOGEST_ID = 9;
    useEffect(() => {
        const uuid = data?.connection_data?.config?.uuidDynamo;
        if (uuid) {
            const cached = ceresDeviceCache[uuid];
            setCeresInfo({ farm: cached?.farm ?? null, data: cached?.data ?? null });

            const param = `/external/${farmId}`;
            const body = { uuid };

            RestAPI.post("apiAdminDropControl", param, { body })
                .then(res => {
                    const data = JSON.parse(JSON.stringify(res));
                    const farm = data?.Item?.farms?.find(f => f.campo_id == farmId);

                    ceresDeviceCache[uuid] = { data, farm };
                    setCeresInfo({ farm: farm ?? null, data });

                })
                .catch(err => console.error(err));
        } else {
            setCeresInfo(null);
        }
    }, [farmId, ceresDeviceCache, data?.connection_data?.config?.uuidDynamo]);

    const detailsTableData = useMemo(() => {
        const result = [];
        if (data?.contactos){
            result.push(
                {
                    key: "contactos",
                    col1: t("marketplace.contactos"),
                    col2: data.contactos
                }
            );
        }
        if (data?.connection_data?.created_at){
            result.push(
                {
                    col1: t("external.connection-date"),
                    col2: dateFormat(data.connection_data.created_at, t, i18n.language, dataFarm.huso_horario)
                }
            );
        }
        if (data?.tipo_formulario === "SEAT" && data?.connection_data?.config?.cant){
            result.push(
                {
                    col1: t("node.quantity"),
                    col2: data.connection_data.config.cant
                }
            );
        }
        if (data?.connection_data?.nombre_sector){
            result.push(
                {
                    col1: t("thead.sector"),
                    col2: data.connection_data.nombre_sector
                }
            );
        }
        if (data?.connection_data?.fecha_ultimo_envio){
            result.push(
                {
                    col1: t("thead.lastUpdate"),
                    col2: dateFormat(data.connection_data.fecha_ultimo_envio, t, i18n.language, dataFarm.huso_horario,true)
                }
            );
        }
        if (data?.connection_data?.tipo_sector?.includes(2)){
            result.push(
                {
                    col1: t("external.associatedIrrZone"),
                    col2: sectorsInfo?.find(sec => sec.sector_id === data.connection_data?.config?.sector_id_riego)?.nombre ?? t("external.noAssociatedZone")
                }
            );
        }
        if (data?.connection_data?.config?.device_id || data?.connection_data?.config?.device_sn){
            result.push({
                col1: t("external.device-serial-number"),
                col2: data.connection_data?.config.device_id || data.connection_data?.config.device_sn
            });
        }
        if (data?.tipo_formulario === "EXT_UFL" && data?.connection_data?.config?.stationId){
            result.push({
                col1: t("external.station-name"),
                col2: UFL.getStationName(data.connection_data.config.stationId)
            });
        }
        if (data?.tipo_formulario === "API_SELFMANAGED" && isManageView){
            result.push(
                {
                    col1: t("sass.integrador"),
                    col2: data.connection_data.nombre ?? "-"
                },
                {
                    col1: t("sass.acceso"),
                    col2: t(`sass.tipoUsuario.${data.connection_data.tipousuario_id}`)
                }
            );
        }
        if (ceresInfo) {
            result.push(
                {
                    col1: t("external.userName"),
                    col2: ceresInfo?.data?.Item?.user_name
                },
                {
                    col1: t("external.flight-date"),
                    col2: ceresInfo?.farm?.flightDate?.slice(0, 10)
                }
            );
        }
        if (data?.tipo_formulario === "API_SDB" && isManageView){
            result.push(
                {
                    col1: t("sdb.email"),
                    col2: data?.connection_data?.email
                },
                {
                    col1: t("sdb.password"),
                    col2: <>
                        {data?.connection_data?.password && !changeInputType ?
                            <>
                                <span>********</span>
                                <span className="pointer ml-1" onClick={() => setChangeInputType(true)}><FontAwesomeIcon icon={faEye} color="gray" /></span>
                            </>
                            : <><span>{data.connection_data.password}</span>
                                <span className="pointer ml-1" onClick={() => setChangeInputType(false)}><FontAwesomeIcon icon={faEyeSlash} color="gray" /></span>
                            </>}
                    </>

                }
            );
        }
        if (data?.childs?.length && data?.marketplace_servicio_id !== AUTOGEST_ID){
            result.push(
                {
                    col1: t("marketplace.dcZones"),
                    col2: (
                        <div style={{ padding: "0" }}>
                            {
                                data.childs.map(c => {
                                    return (
                                        <div key={c.connection_id} style={{ listStyleType: "none" }}>
                                            <Link style={{ textDecoration: "none" }} to={`/farms/marketplace/connected/${c.connection_id}?farm=${farmId}`} >
                                                {c.label || t("marketplace.manage")}
                                            </Link>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    )
                }
            );
        }
        if(data?.tipo_formulario==="API_SELFMANAGED" && data?.connection_data?.api_key){
            result.push(
                {
                    col1: "API Key",
                    col2: <>
                        {data?.connection_data?.api_key && !changeInputTypeAPI ?
                            <>
                                <span>********</span>
                                <span className="pointer ml-1" onClick={() => setChangeInputTypeAPI(true)}><FontAwesomeIcon icon={faEye} color="gray" /></span>
                                <span className="pointer ml-1" onClick={() => {navigator.clipboard.writeText(data?.connection_data?.api_key);toast.success(t("marketplace.clipboardCopy"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });}}><FontAwesomeIcon icon={faCopy} color="gray" /></span>
                            </>
                            : <><span>{data.connection_data.api_key}</span>
                                <span className="pointer ml-1" onClick={() => setChangeInputTypeAPI(false)}><FontAwesomeIcon icon={faEyeSlash} color="gray" /></span>
                                <span className="pointer ml-1" onClick={() => {navigator.clipboard.writeText(data?.connection_data?.api_key);toast.success(t("marketplace.clipboardCopy"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });}}><FontAwesomeIcon icon={faCopy} color="gray" /></span>
                            </>}
                    </>
                }
            );

        }
        return result;
    }, [data, t, dataFarm.huso_horario, sectorsInfo, ceresInfo, isManageView, changeInputType,changeInputTypeAPI, farmId]);

    const col1Template = data => <div>{data.col1}</div>;

    const col2Template = (data) => {
        const roles = ["administrative","technical","comercial"];
        if (!data.col2) return "-";
        if (data.key === "contactos"){
            return (
                <div>
                    {
                        data.col2.map(c => {
                            let label;
                            if (roles.includes(c.role)) label = t(`marketplace.contacto.${c.role}`);
                            else if (c.role === "customer_care") {
                                return(
                                    <div key={c.email} style={{ listStyleType: "none" }}>
                                        <div style={{ overflowWrap: "anywhere" }}>
                                            { t("marketplace.contactCustomCare") }
                                        </div>
                                    </div>
                                );}
                            else label = t("marketplace.contacto.default");
                            return (
                                <div key={c.email} style={{ listStyleType: "none", marginBottom:"1rem" }}>
                                    <div className='label-role'>
                                        { label }
                                    </div>
                                    <div>
                                        { c.name }
                                    </div>
                                    <div style={{ overflowWrap: "anywhere" }}>
                                        { c.email }
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            );
        }
        return <div>{data.col2}</div>;
    };

    const accessTypes = () => {
        if ([295, 757, 4651].includes(data?.otras_configuraciones?.distribuidor_id)) {
            return [
                {
                    col1: t("sass.tipoUsuario.5"),
                    col2: t("marketplace.accessInfo.5")
                }
            ];
        } else if (data?.tipo_formulario === "API_SDB") {
            return [];
        } else {
            return [
                {
                    col1: t("sass.tipoUsuario.5"),
                    col2: t("marketplace.accessInfo.5")
                },
                {
                    col1: t("sass.tipoUsuario.26"),
                    col2: t("marketplace.accessInfo.26")
                },
                {
                    col1: t("sass.tipoUsuario.34"),
                    col2: t("marketplace.accessInfo.34")
                }
            ];
        }
    };
    const signInJohnDeere = async (url) => {
        return new Promise((resolve, reject) => {
            try {
                const width = 500;
                const height = 400;
                const left = window.screenX + (window.outerWidth - width) / 2;
                const top = window.screenY + (window.outerHeight - height) / 2.5;
                const popup = window.open(url, "Sign In", `width=${width},height=${height},left=${left},top=${top}`);
                const interval = setInterval(() => {
                    try {
                        if(popup.closed){
                            interval && clearInterval(interval);
                            reject("CLOSED");
                        }
                        const currentUrl = popup?.location?.href;
                        if (!currentUrl) {
                            return;
                        }
                        const searchParams = new URL(currentUrl).searchParams;
                        const code = searchParams.get("code");
                        if (code) {
                            interval && clearInterval(interval);
                            popup.close();
                            resolve(code);
                        }
                    } catch (e) {
                        if (!(e instanceof DOMException)) {
                            reject(false);
                        }
                    }
                }, 500);
            } catch (e) {
                console.error(e);
                reject(false);
            }
        });
    };
    const openEnableModal = async () => {
        switch (data?.tipo_formulario) {
            case "API":
                setActionDialogState(Integrator.actionDialogState(t, data, farmId));
                break;
            case "API_SELFMANAGED":
                setActionDialogState(SelfManaged.actionDialogState(t, data, paises));
                break;
            case "API_SDB":
                setActionDialogState(SDB.actionDialogState(t, data, farmId));
                break;
            case "EXT_ARABLE":
                setActionDialogState(Arable.actionDialogState(t, data, i18n));
                break;
            case "EXT_UFL":
                setActionDialogState(UFL.actionDialogState(t, data, i18n));
                break;
            case "EXT_CIMIS":
                setLoading(true);
                await RestAPI.get("apiAdminDropControl", `/external/${farmId}/cimisStations`)
                    .then(res => {
                        res.Stations.sort((a,b) => a.Name.localeCompare(b.Name));
                        setActionDialogState(CIMIS.actionDialogState(t, data, i18n, res.Stations));
                        setLoading(false);
                    })
                    .catch(err => {
                        console.error(err);
                        setLoading(false);
                    });
                break;
            case "EXT_JHON_DEERE":{
                JohnDeere.sectoresArray = sectorsInfo.filter(s => s.tipo.includes(1) || s.tipo.includes(2));
                JohnDeere.equiposArray = pumpsys;
                JohnDeere.callbackJohnDeere = `${window?.location?.href.split("/farms")[0]}/callback/jhondeere`;
                JohnDeere.jd_childs = data.childs;
                setLoading(true);

                const { data : johnDeereData } = await axios.get("https://signin.johndeere.com/oauth2/aus78tnlaysMraFhC1t7/.well-known/oauth-authorization-server");

                const url = `${johnDeereData.authorization_endpoint}?response_type=code&scope=ag1 eq1 eq2 offline_access&client_id=${JohnDeere.client_JohnDeere}&state=${farmId}&redirect_uri=${JohnDeere.callbackJohnDeere}`;
                let code = null;
                try {
                    code = await signInJohnDeere(encodeURI(url));
                    if(code && code !== "CLOSED"){
                        const endpoint = `/external/${farmId}/john-deere-credentials`;
                        const restBody = {
                            "token_endpoint":johnDeereData.token_endpoint,
                            "code": code
                        };
                        const response = await RestAPI.post("apiAdminDropControl", endpoint, { body:restBody });
                        setActionDialogState(JohnDeere.actionDialogState(t, {...data,
                            data: {
                                code: code,
                                tokens: response.access_token,
                                organizations:response.organizations
                            }},i18n));
                    }
                    setLoading(false);
                } catch (error) {
                    setLoading(false);
                    console.log(error);
                    if(error !== "CLOSED"){
                        toast.error(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                    }
                }
                break;
            }
            case "EXT_ZENTRACLOUD":
                setActionDialogState(ZentraCloud.actionDialogState(t, data, i18n));
                break;
            case "EXT_DAVIS":
                setActionDialogState(Davis.actionDialogState(t, data, i18n));
                break;
            case "EXT_IRRIMAX":
                setActionDialogState(Irrimax.actionDialogState(t, data, i18n));
                break;
            case "EXT_WEENAT":
                setActionDialogState(Weenat.actionDialogState(t, data, i18n));
                break;
            case "EXT_CERES":
                setActionDialogState(Ceres.actionDialogState(t, data, i18n));
                break;
            case "EXT_AGVIEWER":
                setActionDialogState(AgViewer.actionDialogState(t, data, i18n,dataFarm?.areaInfo?.centi_unidad));
                break;
            case "REQUEST":
                setActionDialogState(Request.actionDialogState(t, data));
                break;
            case "FEATURE":
                setActionDialogState(Feature.actionDialogState(t, data));
                break;
            case "SEAT":
                setActionDialogState(Seat.actionDialogState(t, data));
                break;
            default:
                break;
        }
    };

    const irrigationZonesSelector = useMemo(() => {
        const irrigationSectors = sectorsInfo?.filter(sec => sec.tipo?.includes(3)) || [];
        pumpsys?.sort((a, b) => (a.equipo_orden < b.equipo_orden) ? -1 : 1);
        const result = [];
        if (Array.isArray(pumpsys)){
            for (const equipo of pumpsys){
                const equipoObj = {
                    equipo: equipo.nombre,
                    zones: []
                };
                const sectoresEquipo = irrigationSectors.filter(s => s.equipo[0] === equipo.equipo_id);
                sectoresEquipo.sort((a, b) => {
                    if (a.orden !== b.orden) {
                        return a.orden - b.orden;
                    } else if (a.nombre_alternativo !== b.nombre_alternativo) {
                        if (!a.nombre_alternativo) return 1;
                        if (!b.nombre_alternativo) return -1;
                        return a.nombre_alternativo.localeCompare(b.nombre_alternativo);
                    } else {
                        return a.nombre.localeCompare(b.nombre);
                    }
                });
                for (const sector of sectoresEquipo){
                    equipoObj.zones.push({
                        sector_id: sector.sector_id,
                        nombre: sector.nombre,
                    });
                }
                result.push(equipoObj);
            }
        }
        return result;
    }, [pumpsys, sectorsInfo]);


    const ActionButtons = () => {
        switch (data.tipo_formulario) {
            case "EXT_IRRIMAX":
            case "EXT_WEENAT": {
                const hasSoilZone = data.connection_data?.tipo_sector?.includes(2);
                if (hasSoilZone && irrigationZonesSelector?.length > 0){
                    return (
                        <div className='mkt-button mkt-btn-enable'>
                            <Button
                                label={t("external.associateIrrigation")}
                                onClick={() => {
                                    setActionDialogState(() => ({ ...Common.associateIrrigationZoneDialog(t, data, irrigationZonesSelector) }));
                                }}
                            />
                        </div>
                    );
                }
                return null;
            }
            case "EXT_DAVIS":
                if (data.connection_data?.config?.version === 1){
                    return (
                        <div className='mkt-button mkt-btn-enable'>
                            <Button
                                onClick={() => {
                                    setActionDialogState(() => ({ ...Davis.migrateToV2Dialog(t, data) }));
                                }}
                                label={t("external.migrateToV2")}
                            />
                        </div>
                    );
                }
                return null;
            case "EXT_CERES":
                return (
                    <div className='mkt-button mkt-btn-enable'>
                        <Button onClick={() => {
                            const id = data.connection_data?.external_provider_id;
                            if (!id) return;
                            const newSearch = `?farm=${farmId}&external=${id}`;
                            navigate({ pathname: "/farms/imagealigner", search: newSearch },
                                { state: { expanded: [null], updateTree: true, redirectLink: `/farms/marketplace/connected/${data.connection_id}` } });
                        }} label={t("external.alinear_img")}
                        />
                    </div>
                );
            case "EXT_JHON_DEERE":
                return (
                    <div className='mkt-button mkt-btn-enable'>
                        <Button onClick={async () => {
                            JohnDeere.sectoresArray = sectorsInfo.filter(s => s.tipo.includes(1) || s.tipo.includes(2));
                            JohnDeere.equiposArray = pumpsys;
                            JohnDeere.callbackJohnDeere = `${window?.location?.href.split("/farms")[0]}/callback/jhondeere`;
                            setLoading(true);

                            const { data : johnDeereData } = await axios.get("https://signin.johndeere.com/oauth2/aus78tnlaysMraFhC1t7/.well-known/oauth-authorization-server");

                            const url = `${johnDeereData.authorization_endpoint}?response_type=code&scope=ag1 eq1 eq2 offline_access&client_id=${JohnDeere.client_JohnDeere}&state=${farmId}&redirect_uri=${JohnDeere.callbackJohnDeere}`;
                            let code = null;
                            try {
                                code = await signInJohnDeere(encodeURI(url));
                                if(code && code !== "CLOSED"){
                                    const endpoint = `/external/${farmId}/john-deere-credentials`;
                                    const restBody = {
                                        "token_endpoint":johnDeereData.token_endpoint,
                                        "code": code
                                    };
                                    const response = await RestAPI.post("apiAdminDropControl", endpoint, { body:restBody });
                                    const dataConnected = response?.organizations?.find(o=> parseInt(o.id,10) ===data?.connection_data?.assets?.orgId);
                                    if(dataConnected){
                                        setActionDialogState(JohnDeere.updateJD(t, {...data,
                                            data: {
                                                code: code,
                                                tokens: response.access_token,
                                                organizations:response.organizations
                                            },
                                            dataConnected:{...dataConnected,tokens:response.access_token}}, i18n));
                                    }else{
                                        toast.error(t("marketplace.userJohnDeereNoOrg"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                                    }

                                }
                                setLoading(false);
                            } catch (error) {
                                setLoading(false);
                                if(error !== "CLOSED"){
                                    console.log(error);
                                    toast.error(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                                }
                            }
                        }} label={t("forms.update")}
                        />
                    </div>
                );
            case "API_SDB":
                return (
                    <div className='mkt-button mkt-btn-enable'>
                        <Button onClick={() => setActionDialogState(SDB.updateFormState(t, data))} label={t("forms.update")} />
                    </div>
                );
            case "API_SELFMANAGED":
                return (
                    <div className='mkt-button mkt-btn-enable'>
                        <Button onClick={() => setActionDialogState(SelfManaged.updateAPIAccess(t, data))} label={t("forms.update")} />
                        <div className='enabled' title={t("marketplace.apiCostDisc")} >
                            <span className="blueDisc">
                                {t("marketplace.apiCostDisc")}
                            </span>
                        </div>
                    </div>
                );
            case "SEAT":
                return (
                    <div className='mkt-button mkt-btn-enable'>
                        <Button
                            onClick={data.disabled_state?.disabled ? null : openEnableModal}
                            label={t("forms.habilitar")}
                            disabled={data.disabled_state?.disabled}
                            tooltip={data.disabled_state?.disabled ? data.disabled_state.reason : undefined}
                            tooltipOptions={{ showOnDisabled: true, position: "top", style: { fontSize: "12px", fontFamily: "Montserrat" } }}
                        />
                    </div>
                );
            default:
                return null;
        }
    };
    useEffect(() => {
        document?.getElementById("containerMarketplace")?.scrollTo(0, 0);
    }, []);
    return (
        <>
            {loading && <LoadingDialog />}
            {actionDialogState?.visible && (
                <ActionDialog
                    usuarioInfo={usuarioInfo}
                    connection={data}
                    dialogState={actionDialogState}
                    setDialogState={setActionDialogState}
                />
            )}
            {
                data && (
                    <div>
                        <div className='row'>
                            <div className='col col-sm-2 col-md-3 col-lg-4'>
                                <div className='mkt-return' onClick={() => {
                                    const newSearch = `?farm=${farmId}`;
                                    navigate({ pathname: "/farms/marketplace", search: newSearch });
                                }}
                                >
                                    <span>
                                        <FontAwesomeIcon icon={faArrowLeft} />
                                    </span>
                                    {t("marketplace.return")}
                                </div>
                            </div>
                        </div>
                        <div className='linea-titulo' />
                        <div className='mkt-detail'>
                            <div className='detail-header'>
                                <div className='col-lg-7 col-md-12 col-sm-12 company-detail'>
                                    {data.logo ? (
                                        <img
                                            src={`https://static.dropcontrol.com/${data.logo}`}
                                            alt=""
                                            data-testid="company-logo"
                                        />
                                    ) : (<DefaultCardLogo />)}
                                    {/* <img
                                        src={data.logo ? `https://static.dropcontrol.com/${data.logo}` : defaultLogo}
                                        alt=""
                                    /> */}
                                    <div className='company-info'>
                                        <Chip
                                            className="mkt-chip"
                                            style={{ borderColor: "#1E84A6", color: "#1E84A6" }}
                                            label={t(`marketplace.products.${data.tipo}`)}
                                        />
                                        <div className='service-title'>{data.marketplace_servicio_id===AUTOGEST_ID && data?.connection_data?.nombre?data?.connection_data?.nombre:data.nombre_servicio}</div>
                                        <div className='company-name'>
                                            <a title='Service Link' href={data.link} target='_blank' rel='noreferrer' className='company-name'>
                                                {data.nombre_compania}
                                            </a>
                                        </div>
                                        <div className='mkt-company-location'>
                                            <span className='icon'>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                                                    <path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" />
                                                </svg>
                                            </span>
                                            <span style={{ verticalAlign: "middle" }}>
                                                { data.paises ? data.paises : t("marketplace.global") }
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-4 col-md-12 col-sm-12'>
                                    {!isManageView && (
                                        <div className='mkt-button mkt-btn-enable'>
                                            {Boolean(data.costo_proveedor === "limitedFree") && (
                                                <div className='enabled' title={t("marketplace.limitedFreeCost")} >
                                                    <span className="blueDisc" style={{color:"#58585A"}}>
                                                        {t("marketplace.limitedFreeCost")}
                                                    </span>
                                                </div>
                                            )}
                                            <Button
                                                onClick={data.disabled_state?.disabled ? null : openEnableModal}
                                                label={t("forms.habilitar")}
                                                disabled={data.disabled_state?.disabled}
                                                tooltip={data.disabled_state?.disabled ? data.disabled_state.reason : undefined}
                                                tooltipOptions={{ showOnDisabled: true, position: "top", style: { fontSize: "12px", fontFamily: "Montserrat" } }}
                                            />
                                            <div className='enabled' title={`${services_enabled?.length} ${t("marketplace.habilitados")}`}>
                                                {Boolean(services_enabled?.length && data.marketplace_servicio_id !== AUTOGEST_ID) && (
                                                    <>
                                                        <span>
                                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M14.2669 5.00003C14.8003 5.53337 14.8003 6.40003 14.2669 6.8667L12.4003 8.73337L7.20026 3.53337L9.06693 1.6667C9.60026 1.13337 10.4669 1.13337 10.9336 1.6667L12.1336 2.8667L14.1336 0.866699L15.0669 1.80003L13.0669 3.80003L14.2669 5.00003ZM10.4003 8.8667L9.46693 7.93337L7.60026 9.80003L6.20026 8.40003L8.06693 6.53337L7.13359 5.60003L5.26693 7.4667L4.26693 6.53337L2.40026 8.40003C1.86693 8.93337 1.86693 9.80003 2.40026 10.2667L3.60026 11.4667L0.933594 14.1334L1.86693 15.0667L4.53359 12.4L5.73359 13.6C6.26693 14.1334 7.13359 14.1334 7.60026 13.6L9.46693 11.7334L8.5336 10.8L10.4003 8.8667Z" fill="#579C27" />
                                                            </svg>
                                                        </span>
                                                        <span>
                                                            {`${services_enabled?.length} ${t("marketplace.habilitados")}`}
                                                        </span>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                    {isManageView && !data.connection_data?.is_old && (
                                        <>
                                            <ActionButtons />
                                            <div className='mkt-button mkt-btn-disconnect'>
                                                <Button
                                                    onClick={() => {
                                                        setActionDialogState(Common.disconnectDialog(t, data, farmId));
                                                    }}
                                                    icon={DisconnectIcon}
                                                    label={t("sass.desconectar")}
                                                />
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className='divider' />
                            <div className='detail-body'>
                                <div className='col-lg-7 col-md-12 col-sm-12'>
                                    <div className='description mb-3'>
                                        <p className='detail-title'>
                                            {t("personal.description")}:
                                        </p>
                                        <p className='description-content'>
                                            { data.descripcion }
                                        </p>
                                    </div>
                                    <div className='description-gallery mb-3'>
                                        {
                                            Boolean(data.media.length) && (
                                                <Gallery media={data.media} />
                                            )
                                        }
                                    </div>
                                    {data.costo_proveedor && (
                                        <div className='disclaimer-price mb-3'>
                                            <p className='detail-title'>
                                                {t("marketplace.costoProveedor")}:
                                            </p>
                                            <div className='message mb-3'>
                                                <Message severity="info" text={t("marketplace.disclaimerCost")}  />
                                            </div>
                                            <div className='provider-cost'>
                                                <div className='provider-title'>{data.nombre_servicio}</div>
                                                <div className='cost-container'>
                                                    <div className='title'>{t("marketplace.detalleCosto")}</div>
                                                    <div className='cost'>{data.costo_proveedor==="limitedFree"?t("marketplace.limitedFreeCost"):data.costo_proveedor==="FREE"?t("marketplace.freeCost"):`US $${data.costo_proveedor}`}</div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {data?.otras_configuraciones?.terms_of_service && (
                                        <div className='disclaimer-price mb-3'>
                                            <p className='detail-title'>
                                                {t("marketplace.terms_of_service")}:
                                            </p>
                                            <div className='terms_of_service'>
                                                <ul className='terms-ulList'>
                                                    { data?.otras_configuraciones?.terms_of_service?.[i18n.language]?.map((term,i) => {
                                                        return (
                                                            <li key={`term-${i}`}>{term} </li>
                                                        );
                                                    })}
                                                </ul>
                                            </div>
                                        </div>
                                    )}
                                    { data.tipo === "apiWiseconn" && Boolean(accessTypes().length) && (
                                        <div className='mb-3'>
                                            <div className='detail-title'>
                                                {t("marketplace.accessTypes")}:
                                            </div>
                                            <div>
                                                <DataTable
                                                    showHeaders={false}
                                                    value={accessTypes()}
                                                    showGridlines
                                                    tableClassName="details-table"
                                                    cellClassName="table-cell"
                                                    rowClassName="table-row"
                                                >
                                                    <Column style={{ maxWidth: "140px" }} bodyClassName="col1" field="col1"  />
                                                    <Column bodyClassName="col2" field="col2" />
                                                </DataTable>
                                            </div>
                                        </div>
                                    )}
                                    { Array.isArray(data?.integrator_docs) && data?.integrator_docs?.length && (
                                        <div className='mb-3' style={{display:"flex", flexDirection:"column"}}>
                                            <p className='detail-title'>
                                                {t("marketplace.integratorDocs")}:
                                            </p>
                                            { data.integrator_docs.map(doc => {
                                                return (
                                                    <a key={doc.url} href={doc.url} target="_blank">{doc.label[i18n.language]} </a>
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>
                                <div className='col-lg-4 col-md-12 col-sm-12'>
                                    <div className='detail-title'>
                                        {t("marketplace.categoriesLabel")}:
                                    </div>
                                    <div className='categories mb-3'>
                                        { data.categorias.map(category => {
                                            return (
                                                <span key={category} className='detail-category' style={{ fontSize: "14px", cursor: "auto" }}>
                                                    #{t(`marketplace.categories.${category}`)}
                                                </span>
                                            );
                                        })}
                                    </div>
                                    {Boolean(detailsTableData?.length) && (
                                        <>
                                            <div className='detail-title'>
                                                {t("marketplace.details")}:
                                            </div>
                                            <div className='details mb-3'>
                                                <DataTable
                                                    showHeaders={false}
                                                    value={detailsTableData}
                                                    showGridlines
                                                    tableClassName="details-table"
                                                    cellClassName="table-cell"
                                                    rowClassName="table-row"
                                                    emptyMessage={t("forms.graphNoData")}
                                                >
                                                    <Column bodyClassName="col1" field="col1" body={col1Template} />
                                                    <Column bodyClassName="col2" field="col2" body={col2Template}  />
                                                </DataTable>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </>


    );
};

export default withName(ConnectionDetail, "ConnectionDetailFrag");

